<template>
  <Page color="background">
    <v-container id="donate" class="h-100 pt-6 pb-3 py-md-12 pt-lg-3 container-md">
      <h1 v-show-timeout="[0, 'slide-y']" class="text-h4 text-md-h3 mb-3 mb-md-6" v-html="$jms('donate.title', true)" />
      <p class="body-1 mb-0" v-html="$options.filters?.markdown($jms('donate.body'))" />
      <v-row class="h-100">
        <v-col v-show-timeout="[100, 'fade']" cols="12" md="6">
          <v-card>
            <v-card-title>
              <v-icon left>mdi-bank</v-icon>
              {{ $t('donate.bank.title') }}
            </v-card-title>
            <v-card-text>
              <div v-html="$options.filters?.markdown($jms('donate.bank.body'))"></div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-show-timeout="[100, 'slide-y']" cols="12" md="6" class="mt-n12 mt-md-0">
          <v-card>
            <v-card-title>
              <v-icon left>mdi-bitcoin</v-icon>
              {{ $t('donate.crypto.title') }}
            </v-card-title>
            <v-card-text>
              <div v-html="$options.filters?.markdown($jms('donate.crypto.body'))"></div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </Page>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Page from '@/components/Page.vue'
import Sticky from '@/components/Sticky.vue'
import Rules from '@/utils/rules';

@Component({
  components: {
    Page,
    Sticky,
  }
})
export default class DonateView extends Vue {

  formIsValid = false
  sent = false
  sending = false
  terms = false
  rules: any = {}
  form = {
    name: '',
    email: '',
    subject: '',
    message: ''
  }

  get canSend(): boolean {
    return this.formIsValid && !this.sending;
  }

  onSubmitForm() {
    const form = this.$refs.form as any;
    if (form && form.validate()) {
      this.sending = true;

    }

  }

  created() {
    this.rules = {
      required: (value: string) => Rules.required(value) || this.$t('rules.required'),
    };
  }
}
</script>
